import { fetchAPI } from 'api';
import { OrderStatus } from 'types';

export interface OrderStatusResponse {
  status: OrderStatus;
}

export const fetchOrderStatus = (orderId: string) => {
  return fetchAPI<OrderStatusResponse>(`v1/order/${orderId}/status`);
};

export interface TravelRuleInfoStatus {
  status: boolean;
}

export interface InitiateExternalRefundResponse {
  sendPreviewId: string;
  isInternal: boolean;
}

export const getTravelRuleInfoStatus = async (sendPreviewId: string) => {
  return fetchAPI<TravelRuleInfoStatus>(
    `v1/travel-rule-info/${sendPreviewId}/status`
  );
};

export const completeExternalRefund = (
  orderId: string,
  sendPreviewId: string,
  isInvalidAmountRefund = false
) => {
  return fetchAPI(`v1/order/${orderId}/complete-external-refund`, {
    method: 'POST',
    body: {
      sendPreviewId,
      isInvalidAmountRefund,
    },
  });
};
